import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { DeviceType } from '@ixicare/resources';
import { Settings2 } from 'lucide-react';
import { t } from '~i18n';
import { deviceTypeLabels } from '~modules/devices/utils/deviceLabels';
import { ToolbarAction } from '~components/Tables/DeviceTables/ToolbarAction';

interface Props {
  // Every type the form will write. Empty renders nothing, which is how tabs without a
  // configuration form (gateways, Eview, Twig) opt out.
  types: DeviceType[];
}

/**
 * Opens the site-level configuration for the device types of the current tab.
 *
 * Labelled rather than an icon: the toolbar already has a gear for table settings and every row
 * has one for the device, so a third would not read as "the whole site".
 */
const SiteConfigButton: React.FC<Props> = ({ types }) => {
  const navigate = useNavigate();

  if (types.length === 0) return null;

  return (
    <ToolbarAction
      lucide={Settings2}
      label={t('site-device-config.open')}
      title={t('site-device-config.openTitle', { types: deviceTypeLabels(types).join(', ') })}
      onClick={() => navigate(`/device-overview/site-configuration?types=${types.join(',')}`)}
    />
  );
};

export default SiteConfigButton;
